<template>
    <div class="charge-register max-content">
        <div class="steps">
            <div :class="active >= 1 ? 'active' : ''"><van-icon v-if="active > 1" name="checked" color="#901D22" /><span
                    v-else>1</span>填写信息</div>
            <van-icon name="play" size="18" color="#d8d8d8" />
            <div :class="active >= 2 ? 'active' : ''"><van-icon v-if="active > 2" name="checked" color="#901D22" /><span
                    v-else>2</span>扫码付费</div>
            <van-icon name="play" size="18" color="#d8d8d8" />
            <div :class="active >= 3 ? 'active' : ''"><van-icon v-if="active > 3" name="checked" color="#901D22" /><span
                    v-else>3</span>开票完成注册</div>
        </div>
        <!--  填写信息 -->
        <div class="form" v-if="active == 1">
            <h4 class="htitle">填写<span>注册信息</span></h4>
            <van-form>
                <van-cell-group :border="false">
                    <van-field v-model="name" :border="false" label="姓名" placeholder="请填写姓名" label-class="label"
                        :rules="[{ message: '请输入正确内容' }]" />
                    <van-field v-model="mobile" :border="false" label="电话" placeholder="请填写电话号码" label-class="label"
                        :rules="[{ pattern: mobileReg, message: '请输入正确内容' }]" />
                    <van-field v-model="idCard" :border="false" label="身份证号" placeholder="请填写身份证号" label-class="label"
                        :rules="[{ pattern: idNumReg, message: '请输入正确内容' }]" />
                    <van-field v-model="job_name" :border="false" label="职称" placeholder="请选择职称" label-class="label"
                        :rules="[{ message: '请输入正确内容' }]" />
                    <van-field v-model="hospital" :border="false" label="医院" placeholder="请选择医院" label-class="label"
                        :rules="[{ message: '请输入正确内容' }]" />
                    <van-field v-model="address" rows="1" :autosize="{ maxHeight: 100, minHeight: 60 }" label="邮寄地址"
                        label-class="label" type="textarea" placeholder="请填写邮寄地址" />
                </van-cell-group>
                <p style="font-size: 12px;color: #666;">邮寄地址为赠送图书包用。</p>
            </van-form>
        </div>
        <!-- 扫码付费 -->
        <div class="scan" v-if="active == 2">
            <h4 class="htitle">注册<span>收费</span></h4>
            <p class="info">本次付费分为以下2种金额付款，请严格按照以下2种金额进行付款并截图支付记录，感谢您的支付，协会拥有最终解释权。</p>
            <div class="money">
                <div>{{ pay[0] }}</div>
                <div>{{ pay[1] }}</div>
            </div>
            <div class="pay-qrcode">
                <img src="@/assets/images/Meeting/pay_qrcode.png" alt="">
                <p>长按识别付款</p>
            </div>
            <div class="tips">
                <p style="color: #901D22;">支付注意事项：</p>
                <p>支付成功后，需要<span style="color: #901D22;">上传支付记录截图才可开票；</span> </p>
                <p>请用付款的软件扫码进行开票；</p>
                <p style="color: #901D22;">支付请备注会议名称：第五届血透通路。</p>
            </div>
        </div>
        <!-- 开票 -->
        <div class="invoice" v-if="active >= 3">
            <h4 class="htitle" style="margin-bottom: 5px;">提交<span>支付订单截图</span></h4>
            <p style="color: #901D22;margin-bottom: 20px;font-size: 13px;">截图中需要包含订单号</p>
            <van-field name="uploader">
                <template #input>
                    <van-uploader v-model="images" :after-read="uploadImg" />
                </template>
            </van-field>
            <div class="pay-qrcode">
                <img src="@/assets/images/Meeting/pay_qrcode.png" alt="">
                <p>长按识别开票</p>
            </div>
            <div class="tips">
                <p style="color: #901D22;">开票注意事项：</p>
                <p>请用付款的软件扫码进行开票；</p>
                <p>开票请备注会议名称：第五届血透通路；</p>
                <p>本次发票请于缴费后10个工作日内申请，协会拥有最终解释权。</p>
            </div>
        </div>
        <!-- 按钮 -->
        <div class="btns">
            <div @click="last">{{active<3?'返回':'上一步'}}</div>
            <div v-if="active < 3"
                :class="!(name && mobile && job_name && hospital && idCard && address) && active == 1 ? 'noEnd' : ''"
                @click="next">
                下一步</div>
            <div v-if="active >= 3" @click="uploadVoucher">完成注册</div>
        </div>
        <div id="toast" v-if="showMessage">{{ message }}</div>
    </div>
</template>

<script>
import { MeetingReg, MeetingUploadVoucher, MeetingUploadImg, MeetingRegInfo } from '@/config/interface.js';
import { Toast,Field,Form ,Cell, CellGroup } from 'vant';
export default {
    components: {
        Field,
        Form,
        Cell,
        CellGroup 
    },
    data() {
        return {
            active: 1,
            showMessage: false,
            showNext: false,
            is_finish: 1,
            name: '',
            mobile: '',
            idCard: '',
            job_name: '',
            hospital: '',
            address: '',
            pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
            mobileReg: /^[1][3,4,5,7,8][0-9]{9}$/,
            idNumReg: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            pay: ['大会注册 200元', '护理注册 100元'],
            images: [],
            imageArr: []

            // uploader: [{ url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }],
        };
    },
    mounted() {
        this.active = this.$route.query.step ? this.$route.query.step : 1;
        document.title = this.$route.query.type == 1 ? '线上注册' : "线下注册";
        if (this.$route.query.type == 2) {
            this.pay = ['大会注册 1000元', '护理注册 500元']
        }
        this.getDetail();
    },
    computed: {
        meeting_id() {
            return this.$route.query.meeting_id ? this.$route.query.meeting_id : (this.$route.query.id ? this.$route.query.id : this.$route.query.MT_id);
        },
        type() {
            //	1线上2线下
            return this.$route.query.type ? this.$route.query.type : 1;
        },
    },
    methods: {
        getDetail() {
            const url = MeetingRegInfo;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "get";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.name = res.data.username
                        this.mobile = res.data.mobile
                        this.idCard = res.data.idcard_number
                        this.job_name = res.data.job_name
                        this.hospital = res.data.hospital
                        this.address = res.data.address

                    }
                })
        },
        //下一步
        next() {
            console.log(this.active)
            if (this.active == 1) {
                if (!(this.name && this.mobile && this.idCard && this.job_name && this.hospital && this.address)) {
                    Toast('请填写完整的注册信息')
                } else {
                    common.confirm('提示', '注册信息一旦提交无法修改，是否确认下一步？', () => {
                        this.uploadInfo()
                        this.showNext = true
                    })

                }
            } else if (this.active == 2) {
                this.active = 3
                this.is_finish = 2
            }
        },
        last() {
            if (this.active >= 3) {
                this.active=2
            } else {
                this.$router.go(-1)
            }
        },
        //提交注册信息
        uploadInfo() {

            const url = MeetingReg;
            let params = {
                type_id: this.type,
                meeting_id: this.meeting_id,
                username: this.name,
                mobile: this.mobile,
                idcard_number: this.idCard,
                job_name: this.job_name,
                hospital: this.hospital,
                address: this.address
            }
            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        // Toast('提交成功')
                        this.active = 2;
                        this.is_finish = 2

                    }
                })
        },
        //上传图片     
        uploadImg(file) {
            console.log(file)
            let url = MeetingUploadImg;
            // let params = {
            //     file: file.content
            // }
            const formData = new FormData();
            formData.append('file', file.file);
            const method = "POST";
            fetch(url, formData, method)
                .then((res) => {
                    if (res.code == 0) {
                        console.log(this.images);
                        this.imageArr.push(res.data.path)
                    }
                })
        },
        //上传支付凭证
        uploadVoucher() {
            const url = MeetingUploadVoucher;
            if (!this.imageArr.length) {
                Toast('请上传支付订单截图')
                return
            }
            let params = {
                meeting_id: this.meeting_id,
                image: this.imageArr
            }
            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        Toast('注册成功')
                        setTimeout(() => {
                            this.$router.replace({
                                path: '/VascularNews/Meeting/index?meeting_id='+this.meeting_id
                             })
                        }, 2000)
                    }
                })
        }


    },

}
</script>

<style lang="scss" scoped>
.charge-register {
    padding: 15px;
    width: 100%;
    min-height: 100%;
    background: #fff;

    .steps {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
            padding: 0 10px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #F3F3F3;
            border-radius: 5px;
            color: #666;
            font-size: 12px;

            span {
                background: #D8D8D8;
                color: #666;
                border-radius: 50%;
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                display: block;
                margin-right: 5px;
                font-size: 12px;
            }

            .van-icon {
                margin-right: 5px;
                font-size: 16px;
            }
        }

        .active {
            background: #FFF3F3;
            color: #0E0E0E;

            span {
                background: #901D22;
                color: #fff;
            }

            .van-icon {
                margin-right: 5px;
            }
        }

    }

    .htitle {
        display: flex;
        font-size: 18px;
        margin-bottom: 20px;
        margin-top: 30px;


        span {
            display: block;
            height: 20px;
            border-bottom: 5px solid #FFBFBF;
        }
    }

    .form {
        width: 100%;
        .van-cell-group{
            width: 100%;
            display: flex;
            flex-direction: column;
            
        }
        .van-cell {
            background: #F7F7F8;
            border-radius: 5px;
            margin-bottom: 10px;
            height: 45px;
            overflow: visible;

            .label {
                color: #141414;

            }
        }

        .van-cell:last-child {
            height: auto;
        }
    }

    .btns {
        display: flex;
        position: absolute;
        bottom: 10%;
        justify-content: space-between;
        width: 100%;
        padding: 0 15px;
        left: 0;
        position: relative !important;
        margin-top: 30px;
        padding: 0 !important;


        >div {
            width: 165px;
            height: 45px;
            color: #fff;
            background: #901D22;
            line-height: 45px;
            text-align: center;
            font-size: 16px;
            border-radius: 5px;
        }

        .noEnd {
            opacity: 0.3;
        }
    }

    .scan {
        .info {
            font-size: 13px;
            line-height: 22px;
        }

        .money {
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin-top: 10px;
            margin-bottom: 15px;

            div {
                width: 165px;
                height: 40px;
                background: #F7F7F8;
                font-size: 15px;
                font-weight: 500;
                text-align: center;
                line-height: 40px;
                border-radius: 5px;
            }
        }



    }

    .pay-qrcode {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #666;

        img {
            width: 175px;
            height: auto;
        }
    }

    .tips {
        margin-top: 20px;
        font-size: 13px;
        color: #666;
        line-height: 22px;
    }

    .invoice {
        .van-cell {
            padding: 0 0 15px;
        }

        .van-cell::after {
            right: 0;
            left: 0;
            border-bottom:1px solid #e8eaec;

        }

        .van-uploader__preview {
            border: 0.5px solid #D7D7D7;
            border-radius: 5px;
            overflow: hidden;
            background: rgba(0, 0, 0, 0.5);
            text-align: center;
            color: #fff;
            font-size: 16px;
        }
        .van-uploader__upload{
            background: #dcdee0 ;
        }
        .van-uploader__upload-icon{
            color:#f7f8fa;
        }
    }
}

.toast {
    position: fixed;
    top: 20%;
    width: 90%;
    height: 50px;
    line-height: 50px;

}

.van-uploader,
.van-uploader__preview-image {
    width: 100%;
}

.van-uploader__preview {
    width: 23%;
}

.van-uploader__preview:nth-child(4n) {
    margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/chargeRegister.vue